import { useContext, useEffect } from "preact/hooks";
import { NotificationContext } from "../notification-provider";
import { Toast } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const Notification = ({ message, id, onRemove, type, index }) => {
    const { removeNotification } = useContext(NotificationContext);

    const iconsTypeMap = {
        success: <FontAwesomeIcon icon={faCheckCircle} />,
        danger: <FontAwesomeIcon icon={faExclamationCircle} />,
        warning: <FontAwesomeIcon icon={faExclamationTriangle} />,
        info: <FontAwesomeIcon icon={faInfoCircle} />,
        default: <FontAwesomeIcon icon={faInfoCircle} />,
    };

    const textColorsTypeMap = {
        success: 'text-white',
        danger: 'text-white',
        warning: 'text-white',
        info: 'text-white',
        default: 'text-dark',
    };

    const handleClick = () => {
        if (typeof onRemove === 'function') onRemove(id);
        removeNotification(id);
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            onRemove(id);
            removeNotification(id);
        }, 2500);
        return () => clearTimeout(timer);
    }, [id, onRemove, removeNotification]);

    return (
        <>
            <div className={`${textColorsTypeMap[type]} bg-${type} p-3 rounded-3 mb-3 shadow-sm`} style={{ zIndex: 9999999 }} onClick={handleClick}>
                <div className="d-flex gap-3 align-items-center">
                    <div className="d-flex align-items-center">
                        {iconsTypeMap[type]}
                    </div>
                    <div>
                        {message}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;